import * as React from 'react';
import { IQueryStringParameter, EOutputLookupContext } from '../../helpers';
import { TextField, Button, ButtonType, IDropdownOption } from 'office-ui-fabric-react';
import { ContentEditableTinyMCE } from '../index';

interface IQueryStringParameterProps {

    index: number;
    parameter: IQueryStringParameter;
    updateKey: (index: number, key: string) => void;
    updateValue: (index: number, value: string) => void;
    removeParameter: (index: number) => void;
    outputOptions?: IDropdownOption[];
}

export class QueryStringParameter extends React.Component<IQueryStringParameterProps, {}> {

    render() {

        let { index, parameter, updateKey, updateValue, removeParameter, outputOptions } = this.props;
        return (<tr>
            <td>
                <ContentEditableTinyMCE
                    value={parameter.key}
                    outputOptions={outputOptions}
                    singleLine={true}
                    onBlur={(val) => updateKey(index, val)}
                    tabIndex={(index + 1) * 10}
                    required={true}
                    richText={false}
                    readonly={false}
                    outputLookupContext={EOutputLookupContext.NotSpecified}
                />
            </td>
            <td>
                <ContentEditableTinyMCE
                    value={parameter.value}
                    outputOptions={outputOptions}
                    singleLine={true}
                    onBlur={(val) => updateValue(index, val)}
                    tabIndex={(index + 1) * 11}
                    required={true}
                    richText={false}
                    readonly={false}
                    outputLookupContext={EOutputLookupContext.NotSpecified}
                />
            </td>
            <td>
                <Button tabIndex={(index + 1) * 12} buttonType={ButtonType.icon} icon="Delete" onClick={() => removeParameter(index)} title="Remove parameter" />
            </td>
        </tr>);
    }
}


// WEBPACK FOOTER //
// ./source/ts/components/redirect/query-string-parameter.tsx